import chess from "../images/CHESS_HERO.jpg"
import ecommerce from "../images/ecommerce.webp"
import food from "../images/Food-delivery-11.jpg"
import stream from "../images/stream.png"
import github from "../images/github.jpg"
import objectidentify from "../images/object.jpg"
import webrtc from "../images/webrtc.jpeg"
export const AllProjects = [
    {
        title: "E-Commerce ",
        subtitle: "MERN Stack",
        description:
        "Welcome to the future of eCommerce. I have leveraged the power of the MERN (MongoDB, Express.js, React, Node.js) stack and Tailwind CSS to create a modern and user-friendly online shopping experience.",
        image: ecommerce,
        link: "https://mern-ecommerce-alpha-tawny.vercel.app/",
      },
      {
        title: "Food Delivery",
        subtitle: "MERN Stack",
        description:
          "Experience the joy of food delivery reimagined with this website. Order now and indulge in a culinary adventure unlike any other!",
        image: food,
        link: "https://github.com/amitomksp/food-odering-clone-APP",
      },
      {
        title: "WEBRTC Video Calling App",
        subtitle: "React Application",
        description:
          "This web calling app utilizes the power of Socket.IO, a real-time communication library, seamlessly integrated with React. ",
        image: webrtc,
        link: "https://jsbootcamp.com",
      },
      {
        title: " Live Streamer ",
        subtitle: "Backend Application",
        description:
          "Welcome to our online chess game, where strategy meets entertainment!. Immerse yourself in the timeless game of chess right from the comfort of your browser. ",
        image: stream,
        link: "https://github.com/amitomksp/Streamyard",
      },
      {
        title: "Chess game",
        subtitle: "Frontend Application",
        description:
          "Welcome to our online chess game, where strategy meets entertainment!. Immerse yourself in the timeless game of chess right from the comfort of your browser. ",
        image: chess,
        link: "https://github.com/amitomksp/chess_game",
      },
      {
        title: "Object identify",
        subtitle: "ML Application",
        description:
          "Welcome to our online chess game, where strategy meets entertainment!. Immerse yourself in the timeless game of chess right from the comfort of your browser. ",
        image: objectidentify,
        link: "https://github.com/amitomksp/object-identify",
      },
      {
        title: "For more visit my Github",
        subtitle: "github",
        description:
          "Welcome to our online chess game, where strategy meets entertainment!. Immerse yourself in the timeless game of chess right from the comfort of your browser. ",
        image: github,
        link: "https://github.com/amitomksp",
      },
]


export const skills = [
    "HTML", "CSS", "JavaScript", "React", "Redux", "Node.js", "Express.js","SQL", "MongoDB", "Docker", "Kubernetes", "AWS", "Git/GitHub"
  ]

